import { Link } from "react-router-dom";
import { H4, LI, UL } from "../../../AbstractElements";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { getAPIURL, getUserID, getVendorsList } from "../../../services/helper";
import http from "../../../services/http";
import { toast } from "react-toastify";
import { getCurrentUser } from "../../../services/auth";
import { useState, useEffect } from "react";
import Loader from "../../Loader";

export default function VendorSwitcherHeader() {
  const [isworking, setIsworking] = useState(false);
  const [vendorsList, setVendorsList] = useState([]); // useState to manage the vendor list

  // Fetch vendors list from API or localStorage using useEffect
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const vendors = getVendorsList(); // Fetch from helper or API call
        setVendorsList(vendors);
      } catch (error) {
        toast.error("Error fetching vendors list.");
      }
    };

    fetchVendors();
  }, []); // Empty dependency array ensures it runs only once when the component mounts

  const handleVendorSwitch = async (vendor_id: any) => {
    try {
      setIsworking(true);
      const api_url = getAPIURL();
      const payload = { vendor_id };

      // Make the API call to switch vendors
      const { data: vendor_data } = await http.post(
        `${api_url}/switch-vendor`,
        payload
      );

      const updatedSwitcherList = vendorsList.map((v: any) => {
        if (v.id === vendor_id) {
          v.active = true;
        } else {
          v.active = false;
        }
        return v;
      });

      let existing_tealbo_vendor = getCurrentUser(); // Fetch existing vendor data

      const active_vendor = vendor_id;
      const resp = await http.saveVendorData({ active_vendor });

      const updated_vendor_data = { ...vendor_data.data, active_vendor };

      // Prepare the updated vendor data for local storage
      existing_tealbo_vendor = {
        ...existing_tealbo_vendor,
        vendor_id,
        vendor_data: updated_vendor_data,
        switcher_list: updatedSwitcherList,
      };

      // Save the updated vendor data to local storage under the "tealbo_vendor" key
      localStorage.setItem(
        "tealbo_vendor",
        JSON.stringify(existing_tealbo_vendor)
      );

      toast.success("Vendor switched successfully!");

      // Refresh the page to reflect the changes
      setTimeout(() => {
        window.location.reload(); // This will refresh the page after a successful switch
      }, 100);
    } catch (e: any) {
      toast.error(e.message);
      setIsworking(false);
    }
  };

  if (vendorsList.length === 0) {
    return null;
  }

  return (
    <LI className="profile-nav onhover-dropdown" title="Switch Vendors">
      {isworking && <Loader />}
      <div className="onhover-click">
        <div className="sidebar-image">
          <i className="fa fa-exchange" style={{ color: "white" }}></i>
        </div>
        <div className="sidebar-content">{/* <H4>Vendor Switcher</H4> */}</div>
      </div>
      <UL className="profile-dropdown onhover-show-div simple-list">
        {vendorsList.map((item: any) => (
          <LI key={item.id}>
            <Link to="#" onClick={() => handleVendorSwitch(item.id)}>
              <div className="profile-icon">
                <SvgIcon iconId={"users"} />
              </div>
              <span className={item.active ? "active-vendor" : ""}>
                {item.title}
              </span>
            </Link>
          </LI>
        ))}
      </UL>
    </LI>
  );
}
